import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation DeleteMaintenanceType($companyId: ID!, $id: ID!) {
    deleteMaintenanceType(companyId: $companyId, id: $id) {
      maintenanceType {
        id
      }
      errors {
        path
        message
      }
    }
  }
`
